"use strict";

var _defineProperty = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/defineProperty");

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StartQuoteText = exports.QuoteText = exports.EndQuoteText = exports.Content = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");

var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), (0, _layout.setContainer)({
  size: 'md'
}));

exports.Container = Container;

var QuoteText = _styledComponents.default.h4(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0px;\n  font-weight: normal;\n  ", "\n\n  ", "\n"])), function (props) {
  return (0, _typography.setFont)(_objectSpread({}, props));
}, function (props) {
  return (0, _typography.setFontSizes)({
    mobile: props.bold ? '24px' : '32px',
    tablet_horizontal: props.bold ? '48px' : '48px'
  });
});

exports.QuoteText = QuoteText;

var Content = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  ", "\n\n  padding: 0;\n\n  blockquote {\n    margin: 0px;\n  }\n"])), (0, _layout.setContainer)({
  size: 'md'
}));

exports.Content = Content;

var EndQuoteText = _styledComponents.default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0;\n  right: 0;\n\n  &::before {\n    position: absolute;\n    content: '\u201D';\n    transform: translate3d(-35%, -50%, 0);\n  }\n  font-family: ", ";\n  font-size: ", ";\n\n  display: none;\n"])), function (props) {
  return props.bold ? 'univers-bold' : 'hs-deville';
}, function (props) {
  return props.bold ? '32px' : '48px';
});

exports.EndQuoteText = EndQuoteText;

var StartQuoteText = _styledComponents.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  font-family: ", ";\n  font-size: ", ";\n\n  &::before {\n    position: absolute;\n    content: '\u201C';\n    transform: translate3d(-100%, -18%, 0);\n  }\n"])), function (props) {
  return props.bold ? 'univers-bold' : 'hs-deville';
}, function (props) {
  return props.bold ? '32px' : '48px';
});

exports.StartQuoteText = StartQuoteText;